<template>
  <v-card>
    <v-toolbar
      elevation="0"
      v-if="dialog"
    >
      <v-toolbar-title class="title">
        {{ product.description }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="$emit('close')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <div class="py-4 subtitle-2">Agregar material</div>
      <v-row>
        <v-col cols="12" sm="2">
          <v-text-field
            label="Cantidad"
            v-model.number="quantity"
            type="number"
            min="0"
            dense
            :error-messages="errorMessages.quantity"
            :disabled="loading"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="8">
          <v-autocomplete
            label="Material"
            :items="products"
            dense
            :filter="customFilter"
            item-text="description"
            item-value="commercialCode"
            return-object
            v-model="material"
            :disabled="loading"
            :error-messages="errorMessages.material"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="2">
          <v-icon @click="addMaterial" color="secondary" v-if="!loading">mdi-plus</v-icon>
          <v-progress-circular
            indeterminate
            :size="24"
            color="secondary"
            v-else
          ></v-progress-circular>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text>
      <v-list two-line dense>
        <v-subheader>Insumos requeridos</v-subheader>
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
        >
          <v-list-item-action class="mr-3">
            <input v-if="!loadings[i]" type="number" style="border: none; outline: none; width: 64px; text-align: end;" name="itemQuantity" id="itemQuantity" v-model.number="item.quantity" min="0" @change="changeQuantity($event, i)">
            <div v-else style="width: 64px;" class="d-flex justify-center">
              <v-progress-circular
                indeterminate
                :size="24"
              ></v-progress-circular>
            </div>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title v-text="item.product.description"></v-list-item-title>

            <v-list-item-subtitle class="d-flex align-center"><div class="mr-2">{{ item.material }}</div><MaterialsDialog :product="item.product" :curr="getCurrency" :products="products"></MaterialsDialog></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon @click="removeMaterial(i)" color="error" v-if="!loadingsError[i]">mdi-delete</v-icon>
            <div v-else class="d-flex justify-center">
              <v-progress-circular
                indeterminate
                :size="24"
                color="error"
              ></v-progress-circular>
            </div>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-title v-if="false">
      Costo total: {{ totalCost | currencyFormat(getCurrency) }}
    </v-card-title>
    <v-card-subtitle v-if="false">
      Costo de insumos: {{ totalCost | currencyFormat(getCurrency) }}
    </v-card-subtitle>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import redaApp from '../api/redaApp'
export default {
  name: 'MaterialsPO',
  data () {
    return {
      quantity: 1,
      material: null,
      loading: false,
      step: null,
      errorMessages: {
        quantity: null,
        material: null
      },
      loadings: [],
      loadingsError: [],
      usePO: false
    }
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      current: true
    },
    po: Object,
    products: Array,
    priceList: {
      type: String,
      default: 'general'
    }
  },
  components: {
  },
  watch: {
    currStep (val) {
      this.step = val?.uid || null
    },
    quantity (val) {
      this.errorMessages.quantity = val ? null : 'Debe incluir una cantidad mayor a 0'
    },
    material (val) {
      this.errorMessages.material = null
    },
    items (val) {
      this.loadings.length = 0
      this.loadingsError.length = 0
      if (val?.length) return
      for (let i = 0; i < val.length; i++) {
        this.loadings[i] = false
        this.loadingsError[i] = false
      }
    }
  },
  computed: {
    uidUsed () {
      return this.usePO ? this.po.uid : this.step
    },
    product () {
      return this.productsIndexed[this.po.commercialCode]
    },
    currency () {
      if (this.curr) return this.curr
      const price = this.product.prices?.find((price) => price.priceList === this.priceList)
      return price?.currency || 'CRC'
    },
    items () {
      const poItems = this.po.drm?.length ? this.po.drm : []
      const materials = this.usePO ? poItems : []
      const steps = this.po.childs || []
      if (!this.usePO) {
        const step = steps.find(({ uid }) => uid === this.uidUsed)
        const drm = step?.drm || []
        materials.push(...drm)
      } else {
        for (let i = 0; i < steps.length; i++) {
          const step = steps[i]
          const drm = step.drm || []
          materials.push(...drm)
        }
      }
      const grouped = materials.reduce((acc, current) => {
        if (acc[current.material]) {
          acc[current.material].quantity += current.quantity
        } else {
          acc[current.material] = { ...current }
        }
        return acc
      }, {})

      const result = Object.values(grouped)

      return result.map((mt) => {
        const product = this.productsIndexed[mt.material]
        const cost = this.getCost(product, this.getCurrency)
        return { ...mt, product, cost }
      })
    },
    productsIndexed () {
      return this.products?.reduce((acc, curr) => {
        acc[curr.commercialCode] = curr
        return acc
      }, {})
    },
    totalCost () {
      return this.getCost(this.product, this.getCurrency)
    },
    currStep () {
      if (this.po.currStep) return this.po.currStep
      const task = this.po
      const j = this.po.childs?.findIndex(({ completed }) => Number(completed) < 1)
      if (!j) return task
      const currStep = this.po.childs[j] || task
      return currStep
    },
    ...mapGetters([
      'getExchangeRateUSD',
      'getCurrency'
    ])
  },
  methods: {
    removeMaterial (i) {
      this.loadingsError[i] = true
      const drm = [...this.po.drm]
      drm.splice(i, 1)
      const payload = { drm }
      redaApp.update('tasks', payload, this.uidUsed)
        .catch((e) => {
          console.error(e)
        }).finally(() => {
          this.loadingsError[i] = false
        })
    },
    changeQuantity (val, i) {
      this.loadings[i] = true
      const value = val.target.valueAsNumber ? val.target.valueAsNumber : 0
      const drm = this.po.drm
      drm[i] = { ...drm[i], quantity: value }
      const payload = { drm }
      redaApp.update('tasks', payload, this.uidUsed)
        .catch((e) => {
          console.error(e)
        }).finally(() => {
          this.loadings[i] = false
        })
    },
    addMaterial () {
      if (!(this.quantity && this.material)) {
        if (!this.quantity) this.errorMessages.quantity = 'Debe incluir una cantidad mayor a 0'
        if (!this.material) this.errorMessages.material = 'Debe incluir un material'
        return
      }
      this.loading = true
      const uid = this.uidUsed
      const drm = this.items.map(({ quantity, material }) => ({ quantity, material }))
      const i = drm.findIndex(({ material }) => (material === this.material.commercialCode))
      if (i === -1) {
        drm.push({
          quantity: this.quantity,
          material: this.material.commercialCode
        })
      } else {
        drm[i].quantity += this.quantity
      }
      const payload = { drm }
      redaApp.update('tasks', payload, uid)
        .then(() => {
          this.clean()
        }).catch((e) => {
          console.error(e)
        }).finally(() => {
          this.loading = false
        })
    },
    clean () {
      this.quantity = 1
      this.material = null
    },
    customFilter (item, queryText, itemText) {
      const textOne = item.commercialCode.toLowerCase()
      const textTwo = item.description.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
    },
    getCost (product, currency) {
      if (!product) console.log({ ...this.productsIndexed })
      let value = 0
      const price = product.prices?.length
        ? (product.prices.find(({ priceList }) => priceList === 'general') || product.prices[0])
        : null
      const projectedCostCurrency = product.projectedCostCurrency || 'CRC'
      const exchangeRate = projectedCostCurrency === currency ? 1
        : projectedCostCurrency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
      if (product?.projectedCost) return Number(product.projectedCost * exchangeRate)
      const steps = product?.steps || []
      steps.forEach(step => {
        value += (step.drm?.reduce((acc, { material, quantity }) => {
          const materialCost = this.getCost(this.productsIndexed[material], currency)
          acc += (materialCost * quantity)
          return acc
        }, 0) || 0)
      })
      if (product?.isMaterial && price && !value) {
        const exchangeRate = price.currency === currency ? 1
          : price.currency === 'USD' ? this.getExchangeRateUSD : (1 / this.getExchangeRateUSD)
        return Number(price.price * exchangeRate)
      }
      return value
    }
  }
}
</script>
